import { render } from "./TabAtom.vue?vue&type=template&id=3d0c45bb&scoped=true"
import script from "./TabAtom.vue?vue&type=script&lang=js"
export * from "./TabAtom.vue?vue&type=script&lang=js"

import "./TabAtom.vue?vue&type=style&index=0&id=3d0c45bb&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0c45bb"]])

export default __exports__